import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export type JoinBoardModalGhostFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id' | 'email' | 'fullName'>
  & { nonPublic?: Types.Maybe<(
    { __typename: 'Member_NonPublic' }
    & Pick<Types.Member_NonPublic, 'fullName'>
  )> }
);

export const JoinBoardModalGhostFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JoinBoardModalGhost' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nonPublic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseJoinBoardModalGhostFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      JoinBoardModalGhostFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseJoinBoardModalGhostFragmentResult
  extends Omit<Apollo.UseFragmentResult<JoinBoardModalGhostFragment>, 'data'> {
  data?: JoinBoardModalGhostFragment;
}

export const useJoinBoardModalGhostFragment = ({
  from,
  returnPartialData,
  ...options
}: UseJoinBoardModalGhostFragmentOptions): UseJoinBoardModalGhostFragmentResult => {
  const result = Apollo.useFragment<JoinBoardModalGhostFragment>({
    ...options,
    fragment: JoinBoardModalGhostFragmentDoc,
    fragmentName: 'JoinBoardModalGhost',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as JoinBoardModalGhostFragment };
};
